import {useState} from 'react';
import {useDispatch} from 'react-redux';
import {SET_UPSELL_CONFIRMED} from '~/CreateFabricInvitation/reducers/modals';
import {webViewPendingUpgradeToPremium} from '~/CreateFabricInvitation/webview/webview';
import {Sections} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {webViewModalShowing} from '~/common/fabric/hooks';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {setEditingMobile} from '~/common/fabric/reducers/fabricDesign/actions';
import {REVERT_TO_BASIC} from '~/common/fabric/reducers/fabricDesign/constants';

export const useModals = ({navigate}) => {
  const dispatch = useDispatch();
  const [showUpsellModal, setShowUpsellModal] = useState(false);
  const [showExitPremiumPreviewModal, setShowExitPremiumPreviewModal] = useState(false);

  const upgradeToPremium = () => {
    dispatch({
      type: UPDATE_EVENT_DETAILS,
      payload: {isPremium: true, hideUpsell: true},
    });
    dispatch({
      type: SET_UPSELL_CONFIRMED,
      payload: true,
    });
    window.dataLayer.push({
      event: 'fabric_create_upgrade_customize',
    });
    webViewPendingUpgradeToPremium(true);
  };

  const downgradeBackToBasic = () => {
    dispatch({
      type: REVERT_TO_BASIC,
    });
    dispatch({
      type: UPDATE_EVENT_DETAILS,
      payload: {isPremium: false},
    });
    navigate(Sections.CARD_DESIGN);
    dispatch(setEditingMobile(false));
    window.dataLayer.push({
      event: 'fabric_create_downgrade_customize',
    });
    webViewPendingUpgradeToPremium(false);
    setShowExitPremiumPreviewModal(false);
  };

  const handleShowUpsell = () => {
    webViewModalShowing('upsell');
    setShowUpsellModal(true);
  };

  return {
    showUpsellModal,
    showExitPremiumPreviewModal,
    setShowUpsellModal,
    setShowExitPremiumPreviewModal,
    upgradeToPremium,
    downgradeBackToBasic,
    handleShowUpsell,
  };
};
